import { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import PlayIcon from './Icons/Play_arrow.svg';
import PauseIcon from './Icons/Pause.svg';

const messages = defineMessages({
  playPause: { id: 'playPause', defaultMessage: 'Play/Pause' },
});

const PlayPauseButton = ({ className, audioRef }) => {
  const intl = useIntl();
  const [isPlaying, setIsPlaying] = useState(false); // Tila: onko ääni käynnissä

  const handleToggle = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <button className={className + ' Play-pause'} onClick={handleToggle}>
      <img
        className="Play-icon"
        src={isPlaying ? PauseIcon : PlayIcon}
        alt={intl.formatMessage(messages.playPause)}
      />
    </button>
  );
};

export default PlayPauseButton;
